import { CImg, CInput, CInputGroup, CInputGroupAppend, CLabel } from '@coreui/react';
import * as React from 'react';
import { KCamera, KDrawing } from '.';
import { IImageProvider, IMessageBox, MessageLevelEnum } from '../abstraction';
import { KThumbnail } from './KThumbnail';
import { KPDFViewer } from './KPDFViewer';


interface IProps {
	path: string;
	embedded: boolean;
	visible: boolean;
	description: string;
	showMoreIcon?: string;
	drawMode: boolean;
	camera?: boolean;		// Indique qu'il est possible d'utiliser l'APN pour prendre une photo
	imageProvider: IImageProvider;
	msgboxProvider: IMessageBox;
	onFileRemoved?: () => void;
	onUploadComplete?: (filename: string) => void;
	onUploadError?: (error: any) => void;
}

interface IState {
	path: string;
	imageData: string;
	isThumbVisible: boolean;
	isOpen: boolean;

}

// Composant permettant :
//  - de télécharger ou uploader des pièces jointes
//  - de 'créer' une pièce jointe (pour l'instant uniquement des photos via l'APN)
export class KAttachment extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			path: "",
			imageData: "",
			isThumbVisible: false,
			isOpen: false,
		};
	}

	//#region Local events

	// Clic sur le label
	// On affecte le path à la variable d'état, ce qui provoquera un nouveau rendu et déclenchera le téléchargement
	// (automatique grâce à l'iframe et le src)
	onClick = () => {
		try {
			this.setState({ path: '' }, () => { this.setState({ path: this.props.path }); })
		}

		catch (reason: any) {
			this.props.msgboxProvider.MessageBox("Error", reason, MessageLevelEnum.Error);
			console.log(reason);
		}
	}

	// Prise de photo
	// data : contient les données brutes de l'image
	onSnapshot = (data: string): void => {
		this.props.imageProvider.uploadImg(data)
			.then((result) => {
				if (this.props.onUploadComplete) this.props.onUploadComplete(result.tempPath);
				this.setState({ imageData: data, isThumbVisible: true })
			})
			.catch((error) => {
				if (this.props.onUploadError) this.props.onUploadError(error);
				console.log(error);
			});

		return null;
	};

	onRemoveThumbnailClick = () => {
		this.setState({ imageData: "", isThumbVisible: false })
		if (this.props.onFileRemoved) this.props.onFileRemoved();
	}

	//#endregion 

	//#region Rendus

	// Effectue le rendu du lien en lui meme
	// Si l'attribut 'ShowMoreIcon' a été renseigné, alors on affiche l'icône à la place
	//  et si le path vers le fichier en vide, on n'affiche rien
	renderInput = () => {
		if (this.props.showMoreIcon) {
			if (this.props.path)
				return <CImg className="thumbnail" onClick={this.onClick} src={this.props.imageProvider.getImg(this.props.showMoreIcon)} />
			else
				return null;
		}
		return <CLabel onClick={this.onClick}>{this.props.description}</CLabel>
	}

	// Rendu de la camera pour prise photo
	//
	renderCamera = () => {
		if (!this.props.camera) return null;

		return (
			<CInputGroup>
				<CInput color="default" readOnly={true} value={this.props.path}  ></CInput>
				<CInputGroupAppend>
					<KCamera msgBoxProvider={this.props.msgboxProvider} onPhoto={this.onSnapshot} />
				</CInputGroupAppend>
			</CInputGroup>
		);
	}

	// Rendu de composant en mode "dessiner c'est gagné"
	// Un clic sur '...' ouvrira la page de dessin en plein écran
	//
	renderDrawingCanvas = () => {
		if (!this.props.drawMode) return null;

		return (
			<CInputGroup>
				<CInput color="default" readOnly={true} value={this.props.path} ></CInput>
				<CInputGroupAppend>
					<KDrawing onImageSubmit={this.onSnapshot} />
				</CInputGroupAppend>
			</CInputGroup>
		);
	}

	// ça c'est une balise IFrame qui va automatiquement déclencher le téléchargement
	//
	renderDownloadIframe = () => {
		if (this.state.path) {
			let path = "/apis/getAttachment/" + encodeURI(this.state.path.split('.')[0]);

			if (this.props.embedded) {
				let extension = this.state.path.split('.')[1].toLocaleLowerCase();

				if (extension == "pdf") {
					return <KPDFViewer path={path} />
				}
			}
			return <div style={{ display: 'none' }}><iframe src={path} /></div>
		}
		return null;
	}

	// Une fois la photo réalisée, on affiche une miniature
	// C'est son rendu qui est ici effectué
	//
	renderThumbnail() {
		if (!this.state.isThumbVisible) return null;
		return (<KThumbnail onRemove={this.onRemoveThumbnailClick} src={this.state.imageData} />)
	}

	// Pour déclencher un téléchargement, on utilise un IFRAME
	// Le fait de spécifier la source déclenchera le téléchargement
	render() {
		if (!this.props.visible) return null;

		return (
			<div className="KAttachment">
				{this.renderInput()}
				{this.renderCamera()}
				{this.renderDrawingCanvas()}
				{this.renderDownloadIframe()}
				{this.renderThumbnail()}
			</div>
		)
	}

	//#endregion 

}
